import React from 'react';
import { Button, Form, Dropdown, Input, Message } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { format } from 'date-fns';
import { getOperatorOptionsForColumn } from '../../constants';
import { Label } from '../../../../form-elements/labels/Label';
import styles from './styles.module.scss';

export const FilterRow = ({
  row,
  columnOptions,
  dropdownColumns,
  dropdownOptionsMap,
  onRowChange,
  onRemoveRow,
  isRemoveDisabled,
  hasTimeValidationError,
  timeValidationMessage,
}) => {

  const intl = useIntl();
  const isDropdownColumn = dropdownColumns.includes(row.column);
  const dropdownOptions = dropdownOptionsMap[row.column] || [];

  const handleColumnChange = (e, { value: nextColumn }) => {
    onRowChange(row.id, { column: nextColumn });
  };

  const handleOperatorChange = (e, { value: nextOperator }) => {
    const fields = { operator: nextOperator };
    if (!isDropdownColumn) {
      if (nextOperator === 'is any of') {
        fields.multiValues = row.value ? [row.value] : [];
      } else {
        fields.value = row.column === 'time' ? row.value : (row.multiValues[0] || '');
      }
    }
    onRowChange(row.id, fields);
  };

  const handleDropdownValueChange = (e, { value: nextVal }) => {
    onRowChange(row.id, Array.isArray(nextVal) ? { multiValues: nextVal } : { value: nextVal });
  };

  const handleValueChange = (e) => {
    onRowChange(row.id, { value: e.target.value });
  };

  const isMulti = row.operator === 'is any of';

  return (
    <div className={styles.row}>

      <Form.Field>
        <Label intl="column" />
        <Dropdown
          placeholder={intl.formatMessage({
            id: 'selectColumn',
            defaultMessage: 'Select Column',
          })}
          fluid
          selection
          options={columnOptions}
          value={row.column}
          onChange={handleColumnChange}
        />
      </Form.Field>

      <Form.Field>
        <Label intl="operator" />
        <Dropdown
          placeholder={intl.formatMessage({
            id: 'selectOperator',
            defaultMessage: 'Select Operator',
          })}
          fluid
          selection
          options={getOperatorOptionsForColumn(row.column)}
          value={row.operator}
          onChange={handleOperatorChange}
        />
      </Form.Field>

      <Form.Field>
        <Label intl="value" />
        {isDropdownColumn && (
        <Dropdown
          placeholder="Select"
          fluid
          selection
          search
          multiple={isMulti}
          options={dropdownOptions}
          value={isMulti ? row.multiValues : row.value}
          onChange={handleDropdownValueChange}
        />
        )}
        {row.column === 'time' && (
        <>
          <Input
            fluid
            type="datetime-local"
            placeholder={
        intl.formatMessage({
          id: 'selectDateTime',
          defaultMessage: 'Select Date and Time',
        })
       }
            value={row.value}
            max={format(new Date(), "yyyy-MM-dd'T'HH:mm")}
            onChange={handleValueChange}
            error={hasTimeValidationError}
          />
          {hasTimeValidationError && (
          <Message negative>
            <Message.Content>
              {timeValidationMessage}
            </Message.Content>
          </Message>
          )}
        </>
        )}
      </Form.Field>

      <Button
        icon="trash"
        color="red"
        basic
        type="button"
        onClick={() => onRemoveRow(row.id)}
        disabled={isRemoveDisabled || hasTimeValidationError}
        className={styles.deleteBtn}
      />

    </div>
  );
};
